/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as controlDeviceV1 from "./keyapis_telemetry_control_device_v1.pb"

/**
 * Сервис реализует функционал управления Точками учёта(ТУ)
 */

/**
 * Сервис Точек учёта (ТУ).
 * Авторизация:
 *   - Authorization: Bearer.
 *   - X-Api-Key: apiKey
 */
export class MetricPointServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения ТУ.
   * Разрешения: telemetry_control:metric_point:card, telemetry_control:metric_point:card:own.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений.
   * Метод доступен для: ApiKey: При наличии разрешений
   */
  GetMetricPoint = (req: GetMetricPointRequestDto, init?: RequestInit): Promise<GetMetricPointResponseDto> => {
    return fm.request<GetMetricPointRequestDto, GetMetricPointResponseDto>(`${this.host}/telemetry_control/api/v1/metric_point/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка ТУ.
   * Разрешения: telemetry_control:metric_point:list, telemetry_control:metric_point:list:own.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений.
   * Метод доступен для: ApiKey: При наличии разрешений
   */
  GetMetricPointList = (req?: GetMetricPointListRequestDto, init?: RequestInit): Promise<GetMetricPointListResponseDto[]> => {
    return fm.list<GetMetricPointListRequestDto, GetMetricPointListResponseDto>(`${this.host}/telemetry_control/api/v1/metric_point/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества ТУ.
   * Разрешения: telemetry_control:metric_point:list, telemetry_control:metric_point:list:own.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений.
   * Метод доступен для: ApiKey: При наличии разрешений
   */
  GetMetricPointCount = (req?: GetMetricPointCountRequestDto, init?: RequestInit): Promise<GetMetricPointCountResponseDto> => {
    return fm.request<GetMetricPointCountRequestDto, GetMetricPointCountResponseDto>(`${this.host}/telemetry_control/api/v1/metric_point/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод сохранения ТУ.
   * Поддерживает создание и обновление.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений
   */
  PostMetricPoint = (req: PostMetricPointRequestDto, init?: RequestInit): Promise<PostMetricPointResponseDto> => {
    return fm.request<PostMetricPointRequestDto, PostMetricPointResponseDto>(`${this.host}/telemetry_control/api/v1/metric_point`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления ТУ.
   * Метод доступен для: Token: admin, service, bti, seller, application, owner, employee. Без учета разрешений
   */
  DeleteMetricPoint = (req: DeleteMetricPointRequestDto, init?: RequestInit): Promise<DeleteMetricPointResponseDto> => {
    return fm.request<DeleteMetricPointRequestDto, DeleteMetricPointResponseDto>(`${this.host}/telemetry_control/api/v1/metric_point/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов направлений сортировки
 */
export enum MetricPointPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки
 */
export type MetricPointPagingDirectionTypeResponseEnum = keyof typeof MetricPointPagingDirectionType
/**
 * Справочник типов направлений сортировки
 */
export type MetricPointPagingDirectionTypeRequestEnum = Exclude<MetricPointPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки
 */
export enum MetricPointPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * По типу энергоресурса
   */
  METRIC_TYPE = "METRIC_TYPE",
  /**
   * По типу статуса
   */
  STATUS_TYPE = "STATUS_TYPE",
  /**
   * По Номеру помещения
   */
  ROOM_NUMBER = "ROOM_NUMBER",
  /**
   * По Лейблу помещения
   */
  ROOM_LABEL = "ROOM_LABEL",
  /**
   * По идентификатору объекта строительства
   */
  BUILDING_ID = "BUILDING_ID",
}
/**
 * Справочник типов значений сортировки
 */
export type MetricPointPagingOrderByTypeResponseEnum = keyof typeof MetricPointPagingOrderByType
/**
 * Справочник типов значений сортировки
 */
export type MetricPointPagingOrderByTypeRequestEnum = Exclude<MetricPointPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос удаления ТУ
 */
export type DeleteMetricPointRequestDto = {
  /**
   * Идентификатор
   */
  id: string
}
/**
 * Ответ на запрос удаления ТУ
 */
export type DeleteMetricPointResponseDto = {
}
/**
 * Запрос получения количества ТУ
 */
export type GetMetricPointCountRequestDto = {
  /**
   * Фильтр по ТУ
   */
  filter?: MetricPointFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества ТУ
 */
export type GetMetricPointCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего ТУ
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetMetricPointCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества ТУ
 */
export type GetMetricPointCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly metricPointFilterValidation: MetricPointFilterValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества ТУ
 */
export type GetMetricPointCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly metricPointFilterValidation: MetricPointFilterValidationErrorResponseDto
}>
/**
 * Запрос получения списка ТУ
 */
export type GetMetricPointListRequestDto = {
  /**
   * Фильтр
   */
  filter?: MetricPointFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: MetricPointPagingRequestDto
}>
/**
 * Ответ на запрос получения списка ТУ
 */
export type GetMetricPointListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Точка учета
   */
  readonly data: controlDeviceV1.DeviceMetricPointResponseDto
  /**
   * Ошибка
   */
  readonly error: GetMetricPointListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка ТУ
 */
export type GetMetricPointListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly metricPointFilterValidation: MetricPointFilterValidationErrorRequestDto
  /**
   * Ошибка пагинации  по страницам
   */
  readonly metricPointPagingValidation: MetricPointPagingValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка ТУ
 */
export type GetMetricPointListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка фильтрации
   */
  readonly metricPointFilterValidation: MetricPointFilterValidationErrorResponseDto
  /**
   * Ошибка пагинации  по страницам
   */
  readonly metricPointPagingValidation: MetricPointPagingValidationErrorResponseDto
}>
/**
 * Запрос получения ТУ
 */
export type GetMetricPointRequestDto = {
  /**
   * Идентификатор ТУ
   */
  id: string
}
/**
 * Ответ на запрос получения ТУ
 */
export type GetMetricPointResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Точка учета
   */
  readonly data: controlDeviceV1.DeviceMetricPointResponseDto
}>
/**
 * Фильтр для запроса точек учета.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type MetricPointFilterRequestDto = {
  /**
   * По типу энергоресурса
   */
  deviceMetricPointMetricTypes?: controlDeviceV1.DeviceMetricPointMetricTypeResponseEnum[]
  /**
   * По типу статуса
   */
  deviceMetricPointStatusTypes?: controlDeviceV1.DeviceMetricPointStatusTypeResponseEnum[]
  /**
   * По Номеру помещения
   */
  roomNumbers?: string[]
  /**
   * По Лейблу помещения
   */
  roomLabels?: string[]
  /**
   * По идентификаторам объекта строительства
   */
  buildingIds?: number[]
  /**
   * По ФИАС
   */
  fiasIds?: string[]
  /**
   * По ID привязанных через индикаторы ПУ
   */
  deviceIds?: number[]
  /**
   * По серийным номерам привязанных через индикаторы ПУ
   */
  deviceSerialNumbers?: string[]
  /**
   * По ОРПОНам
   */
  orpons?: string[]
}
/**
 * Фильтр для запроса точек учета.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type MetricPointFilterResponseDto = {
  /**
   * По типу энергоресурса
   */
  deviceMetricPointMetricTypes: controlDeviceV1.DeviceMetricPointMetricTypeResponseEnum[]
  /**
   * По типу статуса
   */
  deviceMetricPointStatusTypes: controlDeviceV1.DeviceMetricPointStatusTypeResponseEnum[]
  /**
   * По Номеру помещения
   */
  roomNumbers: string[]
  /**
   * По Лейблу помещения
   */
  roomLabels: string[]
  /**
   * По идентификаторам объекта строительства
   */
  buildingIds: number[]
  /**
   * По ФИАС
   */
  fiasIds: string[]
  /**
   * По ID привязанных через индикаторы ПУ
   */
  deviceIds: number[]
  /**
   * По серийным номерам привязанных через индикаторы ПУ
   */
  deviceSerialNumbers: string[]
  /**
   * По ОРПОНам
   */
  orpons: string[]
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type MetricPointFilterValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type MetricPointFilterValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Пагинация
 */
export type MetricPointPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType?: MetricPointPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: MetricPointPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано) то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Пагинация
 */
export type MetricPointPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType: MetricPointPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: MetricPointPagingDirectionTypeResponseEnum
  /**
   * Количество.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано) то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Ошибка валидации постраничной пагинации по ТУ.
 * Эти проверки выполняются до обращения в базу данных
 */
export type MetricPointPagingValidationErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Количество передано некорректно
   */
  readonly limit: MetricPointPagingValidationErrorLimitInvalidRequestDto
  /**
   * Сдвиг передан некорректно
   */
  readonly offset: MetricPointPagingValidationErrorOffsetInvalidRequestDto
}>
/**
 * Ошибка валидации постраничной пагинации по ТУ.
 * Эти проверки выполняются до обращения в базу данных
 */
export type MetricPointPagingValidationErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Количество передано некорректно
   */
  readonly limit: MetricPointPagingValidationErrorLimitInvalidResponseDto
  /**
   * Сдвиг передан некорректно
   */
  readonly offset: MetricPointPagingValidationErrorOffsetInvalidResponseDto
}>
/**
 * Причины:
 * - Значение количества < 0 или > 100
 */
export type MetricPointPagingValidationErrorLimitInvalidRequestDto = {
}
/**
 * Причины:
 * - Значение количества < 0 или > 100
 */
export type MetricPointPagingValidationErrorLimitInvalidResponseDto = {
}
/**
 * Причины:
 * - Значение сдвига < 0
 */
export type MetricPointPagingValidationErrorOffsetInvalidRequestDto = {
}
/**
 * Причины:
 * - Значение сдвига < 0
 */
export type MetricPointPagingValidationErrorOffsetInvalidResponseDto = {
}
/**
 * Запрос сохранения ТУ
 */
export type PostMetricPointRequestDto = {
  /**
   * Точка учета
   */
  data: controlDeviceV1.DeviceMetricPointRequestDto
}
/**
 * Ответ на запрос сохранения ТУ
 */
export type PostMetricPointResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Точка учета
   */
  readonly data: controlDeviceV1.DeviceMetricPointResponseDto
  /**
   * Ошибка
   */
  readonly error: PostMetricPointResponseErrorDto
}>
/**
 * Ошибка запроса сохранения ТУ
 */
export type PostMetricPointResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса сохранения ТУ
 */
export type PostMetricPointResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования protobuf
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос удаления ТУ
   */
  "DeleteMetricPointRequest": {
    "kind": "class",
    "text": "Запрос удаления ТУ",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "string",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления ТУ
   */
  "DeleteMetricPointResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления ТУ",
  },
  /**
   * Запрос получения количества ТУ
   */
  "GetMetricPointCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества ТУ",
    "fields": {
      /**
       * Фильтр по ТУ
       */
      "filter": {
        "type": "MetricPointFilter",
        "text": "Фильтр по ТУ",
      },
    },
  },
  /**
   * Ответ на запрос получения количества ТУ
   */
  "GetMetricPointCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества ТУ",
    "fields": {
      /**
       * Всего ТУ
       */
      "data": {
        "type": "int32",
        "text": "Всего ТУ",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetMetricPointCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества ТУ
   */
  "GetMetricPointCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества ТУ",
    "fields": {
      /**
       * Ошибка фильтрации
       */
      "metricPointFilterValidation": {
        "type": "MetricPointFilter.ValidationError",
        "text": "Ошибка фильтрации",
      },
    },
  },
  /**
   * Запрос получения списка ТУ
   */
  "GetMetricPointListRequest": {
    "kind": "class",
    "text": "Запрос получения списка ТУ",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "MetricPointFilter",
        "text": "Фильтр",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "MetricPointPaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка ТУ
   */
  "GetMetricPointListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка ТУ",
    "fields": {
      /**
       * Точка учета
       */
      "data": {
        "type": "Device.MetricPoint",
        "text": "Точка учета",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetMetricPointListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка ТУ
   */
  "GetMetricPointListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка ТУ",
    "fields": {
      /**
       * Ошибка фильтрации
       */
      "metricPointFilterValidation": {
        "type": "MetricPointFilter.ValidationError",
        "text": "Ошибка фильтрации",
      },
      /**
       * Ошибка пагинации  по страницам
       */
      "metricPointPagingValidation": {
        "type": "MetricPointPaging.ValidationError",
        "text": "Ошибка пагинации  по страницам",
      },
    },
  },
  /**
   * Запрос получения ТУ
   */
  "GetMetricPointRequest": {
    "kind": "class",
    "text": "Запрос получения ТУ",
    "fields": {
      /**
       * Идентификатор ТУ
       */
      "id": {
        "type": "string",
        "text": "Идентификатор ТУ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения ТУ
   */
  "GetMetricPointResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения ТУ",
    "fields": {
      /**
       * Точка учета
       */
      "data": {
        "type": "Device.MetricPoint",
        "text": "Точка учета",
      },
    },
  },
  /**
   * Фильтр для запроса точек учета.
   * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
   * При передаче нескольких разных параметров фильтра они работают в выборке через И
   */
  "MetricPointFilter": {
    "kind": "class",
    "text": "Фильтр для запроса точек учета.\nПри передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.\nПри передаче нескольких разных параметров фильтра они работают в выборке через И",
    "fields": {
      /**
       * По типу энергоресурса
       */
      "deviceMetricPointMetricTypes": {
        "type": "Device.MetricPoint.MetricType",
        "text": "По типу энергоресурса",
      },
      /**
       * По типу статуса
       */
      "deviceMetricPointStatusTypes": {
        "type": "Device.MetricPoint.StatusType",
        "text": "По типу статуса",
      },
      /**
       * По Номеру помещения
       */
      "roomNumbers": {
        "type": "string",
        "text": "По Номеру помещения",
      },
      /**
       * По Лейблу помещения
       */
      "roomLabels": {
        "type": "string",
        "text": "По Лейблу помещения",
      },
      /**
       * По идентификаторам объекта строительства
       */
      "buildingIds": {
        "type": "int32",
        "text": "По идентификаторам объекта строительства",
      },
      /**
       * По ФИАС
       */
      "fiasIds": {
        "type": "string",
        "text": "По ФИАС",
      },
      /**
       * По ID привязанных через индикаторы ПУ
       */
      "deviceIds": {
        "type": "int32",
        "text": "По ID привязанных через индикаторы ПУ",
      },
      /**
       * По серийным номерам привязанных через индикаторы ПУ
       */
      "deviceSerialNumbers": {
        "type": "string",
        "text": "По серийным номерам привязанных через индикаторы ПУ",
      },
      /**
       * По ОРПОНам
       */
      "orpons": {
        "type": "int64",
        "text": "По ОРПОНам",
      },
    },
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "MetricPointFilter.ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования protobuf
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования protobuf",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Пагинация
   */
  "MetricPointPaging": {
    "kind": "class",
    "text": "Пагинация",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: ID
       */
      "orderByType": {
        "type": "MetricPointPaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: ID",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "MetricPointPaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Количество.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано) то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Количество.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано) то выставляем значение по умолчанию",
      },
      /**
       * Сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Ошибка валидации постраничной пагинации по ТУ.
   * Эти проверки выполняются до обращения в базу данных
   */
  "MetricPointPaging.ValidationError": {
    "kind": "class",
    "text": "Ошибка валидации постраничной пагинации по ТУ.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Количество передано некорректно
       */
      "limit": {
        "type": "MetricPointPaging.ValidationError.LimitInvalid",
        "text": "Количество передано некорректно",
      },
      /**
       * Сдвиг передан некорректно
       */
      "offset": {
        "type": "MetricPointPaging.ValidationError.OffsetInvalid",
        "text": "Сдвиг передан некорректно",
      },
    },
  },
  /**
   * Причины:
   * - Значение количества < 0 или > 100
   */
  "MetricPointPaging.ValidationError.LimitInvalid": {
    "kind": "class",
    "text": "Причины:\n- Значение количества < 0 или > 100",
  },
  /**
   * Причины:
   * - Значение сдвига < 0
   */
  "MetricPointPaging.ValidationError.OffsetInvalid": {
    "kind": "class",
    "text": "Причины:\n- Значение сдвига < 0",
  },
  /**
   * Запрос сохранения ТУ
   */
  "PostMetricPointRequest": {
    "kind": "class",
    "text": "Запрос сохранения ТУ",
    "fields": {
      /**
       * Точка учета
       */
      "data": {
        "type": "Device.MetricPoint",
        "text": "Точка учета",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения ТУ
   */
  "PostMetricPointResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения ТУ",
    "fields": {
      /**
       * Точка учета
       */
      "data": {
        "type": "Device.MetricPoint",
        "text": "Точка учета",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostMetricPointResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения ТУ
   */
  "PostMetricPointResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения ТУ",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования protobuf
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования protobuf",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Справочник типов направлений сортировки
   */
  "MetricPointPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки
   */
  "MetricPointPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По типу энергоресурса
       */
      "METRIC_TYPE": {
        "i": 2,
        "text": "По типу энергоресурса",
      },
      /**
       * По типу статуса
       */
      "STATUS_TYPE": {
        "i": 3,
        "text": "По типу статуса",
      },
      /**
       * По Номеру помещения
       */
      "ROOM_NUMBER": {
        "i": 4,
        "text": "По Номеру помещения",
      },
      /**
       * По Лейблу помещения
       */
      "ROOM_LABEL": {
        "i": 5,
        "text": "По Лейблу помещения",
      },
      /**
       * По идентификатору объекта строительства
       */
      "BUILDING_ID": {
        "i": 6,
        "text": "По идентификатору объекта строительства",
      },
    },
  },
}